// import React from "react";
// import { Link } from "react-router-dom";


// const ExploreOurCars = () => {
//   const fleetCars = [
//     {
//       image: "/images/fleets/20-Seater-Tempo-Traveller.jpg",
//       title: "Tempo Traveller",
//       seats: "20 Seater",
//       description:
//         "Perfect for family trips, group tours, weddings, and outstation travel.",
//       price: "Starting ₹1299/day",
//     },

//     {
//       image: "/images/fleets/Force-Urbania.jpg",
//       title: "Force Urbania",
//       seats: "12 Seater",
//       description:
//         "Luxury travel experience with premium comfort and modern interiors.",
//       price: "Starting ₹1899/day",
//     },

//     {
//       image: "/images/fleets/32-Seater-Bus.jpg",
//       title: "32 Seater Bus",
//       seats: "32 Seater",
//       description:
//         "Best for corporate events, school trips, and large group tours.",
//       price: "Starting ₹3499/day",
//     },
//   ];

//   return (
// <section
//   className="py-5"
//   style={{
//     backgroundImage:
//       "linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url('/images/backgrounds/card-1-1.jpg')",
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     backgroundRepeat: "no-repeat",
//     position: "relative",
//   }}
// >
//       <div className="container">

//         {/* Section Title */}
//         <div className="text-center mb-5 text-white">
//           <h6
//             style={{
//               color: "#ff6600",
//               fontWeight: "600",
//             }}
//           >
//             EXPLORE OUR CARS
//           </h6>

//           <h2
//             style={{
//               fontWeight: "700",
//               fontSize: "40px",
//             }}
//           >
//             Our Vehicle Fleet
//           </h2>
//         </div>

//         {/* Cards */}
//         <div className="row g-4">
//           {fleetCars.map((car, index) => (
//             <div
//               className="col-xl-4 col-lg-4 col-md-6"
//               key={index}
//             >
//               <div
//                 className="card border-0 shadow-lg h-100"
//                 style={{
//                   borderRadius: "20px",
//                   overflow: "hidden",
//                 }}
//               >

//                 {/* Image */}
//                 <img
//                   src={car.image}
//                   alt={car.title}
//                   className="img-fluid w-100"
//                   style={{
//                     height: "240px",
//                     objectFit: "cover",
//                   }}
//                 />

//                 {/* Content */}
//                 <div className="card-body p-4">

//                   {/* Seater */}
//                   <div
//                     className="mb-3"
//                     style={{
//                       display: "inline-block",
//                       background: "#ff6600",
//                       color: "#fff",
//                       padding: "6px 14px",
//                       borderRadius: "30px",
//                       fontSize: "14px",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {car.seats}
//                   </div>

//                   {/* Title */}
//                   <h4
//                     style={{
//                       fontWeight: "700",
//                     }}
//                   >
//                     {car.title}
//                   </h4>

//                   {/* Description */}
//                   <p
//                     className="text-muted mt-3"
//                     style={{
//                       lineHeight: "1.8",
//                     }}
//                   >
//                     {car.description}
//                   </p>

//                   {/* Bottom */}
//                   <div className="d-flex justify-content-center align-items-center mt-4">


//                    <Link to="/booking">
//   <button
//     className="btn"
//     style={{
//       background: "#000",
//       color: "#fff",
//       borderRadius: "50px",
//       padding: "10px 20px",
//     }}
//   >
//     Book Now
//   </button>
// </Link>

//                   </div>
//                 </div>

//               </div>
//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
//   );
// };

// export default ExploreOurCars;


import React from "react";

const ExploreOurCars = () => {
const fleetCars = [
{
image: "/images/fleets/17-Seater-Tempo-Traveller.jpg",
title: "Tempo Traveller",
seats: "12 Seater",
description:
"Comfortable travel solution for family trips, airport transfers, and small group tours.",
},


{
  image: "/images/fleets/3.jpg",
  title: "Tempo Traveller",
  seats: "17 Seater",
  description:
    "Ideal for corporate outings, pilgrimage tours, weddings, and weekend getaways.",
},

{
  image: "/images/fleets/20-Seater-Tempo-Traveller.jpg",
  title: "Tempo Traveller",
  seats: "20 Seater",
  description:
    "Spacious seating with modern amenities for large family and group travel needs.",
},

{
  image: "/images/fleets/Force-Urbania.jpg",
  title: "Force Urbania",
  seats: "13 Seater",
  description:
    "Premium luxury travel experience with superior comfort and elegant interiors.",
},

{
  image: "/images/fleets/32-Seater-Bus.jpg",
  title: "Mini Bus",
  seats: "32 Seater",
  description:
    "Luxury group transportation with ample space, comfort, and advanced safety features.",
},

{
  image: "/images/fleets/35-Seater-Bus.jpg",
  title: "Luxury Bus",
  seats: "35 Seater",
  description:
    "Perfect for school trips, corporate events, tours, and large group transportation.",
},

];

return (
<section
className="py-5"
style={{
backgroundImage:
"linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url('/images/backgrounds/card-1-1.jpg')",
backgroundSize: "cover",
backgroundPosition: "center",
backgroundRepeat: "no-repeat",
position: "relative",
}}
> <div className="container">

```
    {/* Section Title */}
    <div className="text-center mb-5 text-white">
      <h6
        style={{
          color: "#ff6600",
          fontWeight: "600",
        }}
      >
        EXPLORE OUR FLEET
      </h6>

      <h2
        style={{
          fontWeight: "700",
          fontSize: "40px",
        }}
      >
        Our Premium Vehicle Fleet
      </h2>
    </div>

    {/* Cards */}
    <div className="row g-4">
      {fleetCars.map((car, index) => (
        <div
          className="col-xl-4 col-lg-4 col-md-6"
          key={index}
        >
          <div
            className="card border-0 shadow-lg h-100"
            style={{
              borderRadius: "20px",
              overflow: "hidden",
            }}
          >
            {/* Image */}
            <img
              src={car.image}
              alt={`${car.title} ${car.seats}`}
              className="img-fluid w-100"
              style={{
                height: "240px",
                objectFit: "cover",
              }}
            />

            {/* Content */}
            <div className="card-body p-4">

              {/* Seater */}
              <div
                className="mb-3"
                style={{
                  display: "inline-block",
                  background: "#ff6600",
                  color: "#fff",
                  padding: "6px 14px",
                  borderRadius: "30px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {car.seats}
              </div>

              {/* Title */}
              <h4
                style={{
                  fontWeight: "700",
                }}
              >
                {car.title}
              </h4>

              {/* Description */}
              <p
                className="text-muted mt-3"
                style={{
                  lineHeight: "1.8",
                }}
              >
                {car.description}
              </p>

              {/* WhatsApp Button */}
              <div className="d-flex justify-content-center align-items-center mt-4">
                <a
                  href={`https://wa.me/919529697070?text=Hello, I am interested in booking the ${car.title} (${car.seats}). Please share the details.`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button
                    className="btn"
                    style={{
                      background: "#000000",
                      color: "#fff",
                      borderRadius: "50px",
                      padding: "10px 20px",
                      border: "none",
                      fontWeight: "600",
                    }}
                  >
                    {/* <i className="fab fa-whatsapp me-2"></i> */}
                    Book Now
                  </button>
                </a>
              </div>

            </div>
          </div>
        </div>
      ))}
    </div>

  </div>
</section>

);
};

export default ExploreOurCars;
